import React from 'react';
import keyboardTriggerBasic from '../../../utils/keyboard-trigger';

function Stepper(props: { steps: string[]; activeIndex: number; setActiveStep: (text: number) => void }): JSX.Element {
  const { steps, activeIndex, setActiveStep } = props;

  return (
    <div className="stepper">
      <ul className="multi-step-list">
        {steps.map((step, i) => {
          return (
            <li key={step} className={`multi-step-item ${activeIndex === i ? 'active' : ''} `}>
              <div className="item-wrap">
                <a
                  onClick={() => setActiveStep(i)}
                  onKeyPress={(e) => {
                    keyboardTriggerBasic(e, () => {
                      setActiveStep(i);
                    });
                  }}
                  className={`item-link ${activeIndex !== i ? 'link' : ''} `}
                  role="button"
                  tabIndex={activeIndex !== i ? 0 : -1}
                >
                  {i < activeIndex && <span className="ic-checked" />}
                  <span className={` ${i < activeIndex ? 'item-number__hide' : 'item-number'}`}>{i + 1}</span>
                  <span className="item-title">{step}</span>
                </a>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default Stepper;
